import { useState } from 'react'
import Link from '../TravelokaLink'
import { ActiveLink } from 'components'
import Image from 'components/Image/SimpleImage'
import ensureBasePath from '../../lib/ensureBasePath'
import { trackFor } from 'lib/tracker/utils'

export const Header = () => {
  const [active, setActive] = useState(false)

  const clickNav = () => setActive(!active)

  const logoSrc = ensureBasePath('/images/icons/logo.svg')
  const linkedinLogoSrc = ensureBasePath('/images/icons/linkedin.svg')
  const instagramLogoSrc = ensureBasePath('/images/icons/instagram.png')

  // const trackEventClick = () => {
  //   trackFor({
  //     fbPixel: {
  //       event: 'CareerSiteEvent',
  //       event_name: 'CareerSiteEvent',
  //     },
  //     googleConversion: {
  //       conversion_label: 'nolYCIyKm8IDEP-ZgNAo',
  //       event_name: 'CareerSiteEvent',
  //     },
  //     linkedinInsight: {
  //       conversion_id: '9193465',
  //     },
  //     tiktokPixel: {
  //       event: 'ClickButton',
  //       click_button: 'Event',
  //     },
  //   })
  // }

  const trackLinkedInClick = () => {
    trackFor({
      fbPixel: {
        event: 'CareerSiteLinkedin',
        event_name: 'CareerSiteLinkedin',
      },
      googleConversion: {
        conversion_label: '5aU-CI-Km8IDEP-ZgNAo',
        event_name: 'CareerSiteLinkedin',
      },
      linkedinInsight: {
        conversion_id: '9193473',
      },
      tiktokPixel: {
        event: 'ClickButton',
        click_button: 'LinkedIn',
      },
    })
  }

  const trackInstagramClick = () => {
    trackFor({
      fbPixel: {
        event: 'CareerSiteInstagram',
        event_name: 'CareerSiteInstagram',
      },
      googleConversion: {
        conversion_label: 'UcVYCNHAv9QDEP-ZgNAo',
        event_name: 'CareerSiteInstagram',
      },
      linkedinInsight: {
        conversion_id: '9921801',
      },
      tiktokPixel: {
        event: 'ClickButton',
        click_button: 'Instagram',
      },
    })
  }

  return (
    <div className="navbar-wrapper">
      <nav className="navbar is-transparent">
        <div className="navbar-brand">
          <Link href="/" replace>
            <a className="navbar-item">
              <Image width={139} height={27} layout="fixed" src={logoSrc} alt="Traveloka logo" />
            </a>
          </Link>
          <a className="navbar-burger burger" onClick={clickNav}>
            <span />
            <span />
            <span />
          </a>
        </div>
        <div className={active ? 'navbar-menu is-active' : 'navbar-menu'}>
          <div className="navbar-end">
            <ActiveLink
              href="/"
              activeClass="active"
              className="navbar-item"
              alt="about traveloka"
              title="About Traveloka"
              onClick={clickNav}
            />
            <ActiveLink
              href="/traveloka-life"
              activeClass="active"
              className="navbar-item"
              alt="life at traveloka"
              title="Life at Traveloka"
              onClick={clickNav}
            />
            <ActiveLink
              href="/student-graduate"
              activeClass="active"
              className="navbar-item"
              alt="student &amp; graduate"
              title="Student &amp; Graduate"
              onClick={clickNav}
            />
            <ActiveLink
              href="/vacancies"
              activeClass="active"
              className="navbar-item"
              alt="vacancies"
              title="Vacancies"
              onClick={clickNav}
            />

            {/* <a
              alt="events"
              target="_blank"
              className="navbar-item tvlk-events"
              href="https://discovertraveloka.com/"
              onClick={trackEventClick}
              rel="noreferrer">
              <div>
                <span>Events</span>
              </div>
            </a> */}
          </div>
        </div>

        <a
          alt="instagram"
          target="_blank"
          className="navbar-item instagram"
          href="https://www.instagram.com/humansoftraveloka/"
          onClick={trackInstagramClick}
          rel="noreferrer">
          <Image width={40} height={40} layout="fixed" src={instagramLogoSrc} alt="Instagram" />
        </a>

        <a
          alt="linkedin"
          target="_blank"
          className="navbar-item linkedin"
          href="https://www.linkedin.com/company/traveloka-com/"
          onClick={trackLinkedInClick}
          rel="noreferrer">
          <Image width={20} height={20} layout="fixed" src={linkedinLogoSrc} alt="LinkedIn" />
        </a>
      </nav>
    </div>
  )
}

export default Header
